// How long the Intertown booking screen waits for each lookup before it gives up and
// offers "Try again". Without a limit a stalled lookup (a weak connection, a map
// library that never answers) left the button on "Calculating…", disabled, with no
// message and nothing the rider could do.

// Finding the destination town on the map (the first time on a device; after that it is remembered).
export const TOWN_LOOKUP_TIMEOUT_MS = 12000;
// The server's fare for the trip (a custom trip also asks Google for the route first).
export const QUOTE_TIMEOUT_MS = 20000;

export class TimeoutError extends Error {
  constructor(label, ms) {
    super(`${label}_timeout`);
    this.name = 'TimeoutError';
    this.code = 'timeout';
    this.ms = ms;
  }
}

export const isTimeoutError = (error) => error instanceof TimeoutError;

/**
 * Settles like `promise`, or rejects with a TimeoutError after `ms`. The timer is always
 * cleared. The wrapped work is not cancelled: if it finishes late its result is ignored.
 */
export function withTimeout(promise, ms, label = 'lookup') {
  let timer;
  const limit = new Promise((_, reject) => {
    timer = setTimeout(() => reject(new TimeoutError(label, ms)), ms);
  });
  return Promise.race([promise, limit]).finally(() => clearTimeout(timer));
}
